<mat-card class="address-card mat-elevation-z0">
  <mat-card-title>
    <span>{{ label }}</span>
    <button mat-flat-button color="primary" (click)="openSearchAddressDialog()">
      {{ value ? 'Edit' : 'Add' }}
      <mat-icon class="title-button-icon">{{ value ? 'edit' : 'add' }}</mat-icon>
    </button>
  </mat-card-title>
  <mat-card-content>
    <div *ngIf="value" class="address-value">
      <p>
        {{ formattedAddress }}
        <br/>
        {{ formattedCoordinates }}
      </p>
    </div>
    <div *ngIf="!value" class="address-value">
      <p>No address</p>
    </div>
    <mat-expansion-panel #details [class.closed]="!details.expanded" class="mat-elevation-z0" *ngIf="value">
      <mat-expansion-panel-header>
        <mat-panel-title>Details</mat-panel-title>
      </mat-expansion-panel-header>
      <ngx-json-viewer
        *ngIf="value && details.expanded"
        class="json-viewer"
        [json]="value"
      ></ngx-json-viewer>
    </mat-expansion-panel>
  </mat-card-content>
</mat-card>